import React, { Component } from 'react'
import actions from 'redux/actions'
import { connect } from 'redaction'
import { compose, constants } from 'common/helpers'

import injectGlobals from 'decorators/injectGlobals'

import QueueBanner from 'components/banners/QueueBanner/QueueBanner'
import ShippedBanner from 'components/banners/ShippedBanner/ShippedBanner'
import GiftSetsBanner from 'components/banners/GiftSetsBanner/GiftSetsBanner'
import ShippingDelayBanner from 'components/banners/ShippingDelayBanner/ShippingDelayBanner'


const bannersNames = {
  queueBanner: 'queueBanner',
  shippedBanner: 'shippedBanner',
  giftSetsBanner: 'giftSetsBanner',
  shippingDelayBanner: 'shippingDelayBanner',
}


class HeaderBanner extends Component {

  state = {
    isClosed: false,
  }

  hide = (bannerName) => {
    actions.misc.cookies.setSessionItem(bannerName, true)

    this.setState({
      isClosed: true,
    })
  }

  closePrefixedBanner = (bannerName, bannerPrefix) => {
    actions.models.ui.resetClosedPopupsByPrefix(bannerPrefix)
      .then(() => {
        actions.models.ui.setClosedPopup(bannerName)
      })

    this.setState({
      isClosed: true,
    })
  }

  render() {
    const { isClosed } = this.state
    const {
      isQueueFetched, isGiftSetsBannerVisible, isQueueBannerVisible, shippedBanner,
      isShippingDelayBannerVisible,
    } = this.props

    if (!isQueueFetched || isClosed) {
      return null
    }

    if (isGiftSetsBannerVisible) {
      return (
        <GiftSetsBanner onClose={() => this.hide(bannersNames.giftSetsBanner)} />
      )
    }

    if (isQueueBannerVisible) {
      return (
        <QueueBanner onClose={() => this.hide(bannersNames.queueBanner)} />
      )
    }

    if (shippedBanner) {
      const { bannerName, bannerPrefix, shippedItem } = shippedBanner

      return (
        <ShippedBanner
          shippedItem={shippedItem}
          onClose={() => this.closePrefixedBanner(bannerName, bannerPrefix)}
        />
      )
    }

    if (isShippingDelayBannerVisible) {
      return (
        <ShippingDelayBanner onClose={() => this.hide(bannersNames.shippingDelayBanner)} />
      )
    }

    return null
  }
}


export default compose(
  injectGlobals(({ getCookieValue, getFeatureToggle }) => ({
    queueBannerCookie: getCookieValue(bannersNames.queueBanner),
    giftSetsBannerCookie: getCookieValue(bannersNames.giftSetsBanner),
    shippingDelayBannerCookie: getCookieValue(bannersNames.shippingDelayBanner),
    isGiftSetsSubHeaderBannerEnabled: getFeatureToggle(constants.features.giftSetsSubHeaderBanner),
    isShippingDelayBannerEnabled: getFeatureToggle(constants.features.delayBanner),
  })),
  connect({
    isQueueFetched: 'models.queue.isFetched',
    isGiftSetsBannerVisible: (state, props) => {
      const { routing: { location: { pathname } } } = state
      const { giftSetsBannerCookie, isGiftSetsSubHeaderBannerEnabled } = props

      const isAvailablePathname = !([ '/team', '/blogger', '/thankyou', '/affiliate_program', '/press', '/contact',
        '/faq', '/terms', '/giftset', '/giftset-men', '/skincare-set' ].includes(pathname))

      const isBannerVisible = (
        isGiftSetsSubHeaderBannerEnabled
        && !giftSetsBannerCookie
      )

      return isBannerVisible && isAvailablePathname
    },
    isQueueBannerVisible: (state, props) => {
      const {
        models: {
          queue: { items },
          subscription: { subscriptionDate },
        },
        routing: {
          location: { pathname },
        },
      } = state
      const { queueBannerCookie } = props

      const subDate = subscriptionDate ? new Date(subscriptionDate) : 0
      const activeTime = 60 * 60 * 12 * 1000
      const isTimeout = Date.now() - subDate > activeTime
      const isEmptyQueue = items.every(({ empty }) => empty)
      const isAvailablePathname = /\/subscription\/main-(women|men)/.test(pathname)

      return (
        !queueBannerCookie
        && !isTimeout
        && isEmptyQueue
        && isAvailablePathname
      )
    },
    shippedBanner: (state) => {
      const {
        models: {
          queue: { items },
          ui: { closedPopups },
        },
        routing: {
          location: { pathname },
        },
      } = state

      const isAvailablePathname = /\/subscription\/main-(women|men)/.test(pathname)

      if (!isAvailablePathname) {
        return
      }

      const shippedItem = items.find(({ tracking }) => tracking)

      if (shippedItem) {
        const { tracking: { id } } = shippedItem
        // We create key for each tracking id
        const bannerName = `${bannersNames.shippedBanner}_${id}`

        if (!closedPopups[bannerName]) {
          return {
            bannerName,
            bannerPrefix: `${bannersNames.shippedBanner}_`,
            shippedItem,
          }
        }
      }
    },
    isShippingDelayBannerVisible: (state, props) => {
      const {
        models: {
          queue: { items },
        },
        routing: {
          location: { pathname },
        },
      } = state
      const { shippingDelayBannerCookie, isShippingDelayBannerEnabled } = props

      const firstItemInQueue = items[0]

      const isAvailablePathname = /\/subscription\/main-(women|men)/.test(pathname)

      return (
        isShippingDelayBannerEnabled
        && !shippingDelayBannerCookie
        && isAvailablePathname
        && firstItemInQueue
        && firstItemInQueue.status.includes(constants.queueItemStatuses.locked)
      )
    },
  }),
)(HeaderBanner)
